'use client';

import { Theme } from '@radix-ui/themes';
import ThemeInitializer from './ThemeInitializer';

interface ClientThemeProviderProps {
  children: React.ReactNode;
}

export default function ClientThemeProvider({
  children
}: ClientThemeProviderProps) {
  return (
    <Theme>
      <ThemeInitializer />
      {children}
    </Theme>
  );
}
